import React, { useState } from "react";
import "./App.css";

const shoesData = [
  {
    id: 1,
    name: "AirWave Runner",
    price: 2999,
    image:
      "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    name: "StreetFlex Casuals",
    price: 1999,
    image:
      "https://images.pexels.com/photos/2529150/pexels-photo-2529150.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    name: "ProCourt Sneakers",
    price: 3499,
    image:
      "https://images.pexels.com/photos/19090/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 4,
    name: "UrbanWalk Sports",
    price: 2599,
    image:
      "https://images.pexels.com/photos/2529151/pexels-photo-2529151.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

function App() {
  const [cart, setCart] = useState([]);

  const handleAddToCart = (shoe) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === shoe.id);

      if (existingItem) {
        return prevCart.map((item) =>
          item.id === shoe.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [...prevCart, { ...shoe, quantity: 1 }];
    });
  };

  const handleDecreaseQuantity = (id) => {
    setCart((prevCart) => {
      const updatedCart = prevCart
        .map((item) =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        )
        .filter((item) => item.quantity > 0); // remove if quantity becomes 0

      return updatedCart;
    });
  };

  const totalAmount = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <div className="app">
      <h1 className="main-title">Assignment - 3 Shoe Store</h1>
      <p className="subtitle">
        Browse shoes on the left and manage your cart on the right 🛒
      </p>

      <div className="store-layout">
        {/* Left side - Shoes */}
        <div className="shoes-section">
          <h2 className="section-title">Available Shoes</h2>
          <div className="shoes-grid">
            {shoesData.map((shoe) => (
              <div key={shoe.id} className="shoe-card">
                <img
                  src={shoe.image}
                  alt={shoe.name}
                  className="shoe-image"
                />
                <h3 className="shoe-name">{shoe.name}</h3>
                <p className="shoe-price">₹ {shoe.price}</p>
                <button
                  className="btn primary-btn"
                  onClick={() => handleAddToCart(shoe)}
                >
                  Add to Cart
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Right side - Cart */}
        <div className="cart-section">
          <h2 className="section-title">Shopping Cart</h2>

          {cart.length === 0 ? (
            <p className="empty-cart">Your cart is empty. Start adding shoes! 👟</p>
          ) : (
            <>
              <ul className="cart-list">
                {cart.map((item) => (
                  <li key={item.id} className="cart-item">
                    <div>
                      <p className="cart-item-name">{item.name}</p>
                      <p className="cart-item-price">
                        ₹ {item.price} × {item.quantity}
                      </p>
                    </div>
                    <div className="cart-actions">
                      <button
                        className="btn small-btn"
                        onClick={() => handleDecreaseQuantity(item.id)}
                      >
                        -
                      </button>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="cart-total">
                <span>Total:</span>
                <span className="total-amount">₹ {totalAmount}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
